export var TextType;
(function (TextType) {
    TextType["h1"] = "h1";
    TextType["h2"] = "h2";
    TextType["h3"] = "h3";
    TextType["h4"] = "h4";
    TextType["h5"] = "h5";
    TextType["h6"] = "h6";
    TextType["body"] = "body";
    TextType["custom"] = "custom";
})(TextType || (TextType = {}));
//# sourceMappingURL=index.types.js.map